"use client";

import { useIntl } from "react-intl";

import type { IFormInputs } from "types/uiSchema";
import { Fieldset } from "ui/Fieldset";
import { ReadMore } from "ui/ReadMore";

interface ClausesProps {
    uiData: IFormInputs;
}

export default function Clauses({ uiData }: ClausesProps) {
    const { formatMessage } = useIntl();
    const dictionary = uiData["x-dictionary"];

    if (!dictionary || dictionary?.length === 0) return null;

    return (
        <Fieldset title={formatMessage({ id: "clauses" })} variant="grey">
            {dictionary.map(({ key, value }, i) => (
                <ReadMore key={key} text={value} labelContext={`${formatMessage({ id: "clause" })} ${i + 1}`} />
            ))}
        </Fieldset>
    );
}
